var map = {
	"./01/1.png": "NDxj",
	"./01/2.png": "HOFH",
	"./01/3.png": "K6mk",
	"./01/4.png": "4fuz",
	"./01/5.png": "UgwN",
	"./01/6.png": "Ck5N",
	"./01/7.png": "Tuni",
	"./01/8.png": "driU",
	"./01/9.png": "gqcO",
	"./02/1.png": "I0t2",
	"./02/2.png": "fgSv",
	"./02/3.png": "oxyr",
	"./02/4.png": "Mwcl",
	"./02/5.png": "AXRP",
	"./02/6.png": "c14X",
	"./03/1.png": "eKXl",
	"./03/2.png": "Rhco",
	"./03/3.png": "e+Jb",
	"./03/4.png": "Bxs5",
	"./03/5.png": "KHgE",
	"./03/6.png": "W42E",
	"./03/7.png": "eq+7",
	"./03/8.png": "8FT2",
	"./03/9.png": "SsSj",
	"./04/1.png": "Y+CI",
	"./04/2.png": "voV+",
	"./04/3.png": "0JtB",
	"./04/4.png": "qZu3",
	"./04/5.png": "wx8d",
	"./04/6.png": "6QdW",
	"./05/1.png": "r00g",
	"./bg.png": "4jXZ",
	"./info_content_box.png": "P1wR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CBfo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version ^\.\/.*\.png$
// module id = CBfo
// module chunks = 1